export default __webpack_public_path__ + "static/media/Belt of the Silent Slayer.d2c90ef0.jpg";